<div class="bp-modal-container">
	<div class="bp-modal mod-lg">
		<bp-modal-header class="font-semibold" [title]="'choose_a_wallet_selection_modal' | translate">
			<a right (click)="closeAll()" (keydown.enter)="closeAll()" [tabIndex]="0">{{'cancel' | translate}}</a>
		</bp-modal-header>
		<div class="bp-modal-body modal-grey-background">
			<div class="bp-modal-body-section">
				<tradable-wallet
					[ngClass]="'modal-grid mod-two-cols'"
					[tradableWallets]="getTradables()"
					[tradableId]="tradableId"
					(onSelect)="onClick($event)"></tradable-wallet>
			</div>
		</div>
	</div>
</div>
